import React from 'react';
import PropTypes from 'prop-types';
import CubeLoaderOverlay from 'common/components/CubeLoaderOverlay';
import { colorAppShadedBackground } from 'common/styles/colors';

const baseClassName = 'WorkspaceLoaderOverlay';

const WorkspaceLoaderOverlay = ({ className, loading, text }) => {
    if (!loading) {
        return null;
    }

    return (
        <div className={`${baseClassName} ${className}`.trim()}>
            <CubeLoaderOverlay backgroundColor={colorAppShadedBackground} text={text} />
        </div>
    );
};

WorkspaceLoaderOverlay.propTypes = {
    className: PropTypes.string,
    loading: PropTypes.bool,
    text: PropTypes.string,
};

WorkspaceLoaderOverlay.defaultProps = {
    className: '',
    loading: true,
    text: '',
};

export default WorkspaceLoaderOverlay;
